var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatedNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18.5,
    width: 15,
    height: 12,
    rx: 1,
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2037 15.1102C15.8151 14.7216 15.6208 14.5273 15.548 14.3032C15.484 14.1061 15.484 13.8939 15.548 13.6968C15.6208 13.4727 15.8151 13.2784 16.2037 12.8898L18.8898 10.2037C19.2784 9.81513 19.4727 9.62083 19.6968 9.54803C19.8939 9.48399 20.1061 9.48399 20.3032 9.54803C20.5273 9.62083 20.7216 9.81513 21.1102 10.2037L23.7963 12.8898C24.1849 13.2784 24.3792 13.4727 24.452 13.6968C24.516 13.8939 24.516 14.1061 24.452 14.3032C24.3792 14.5273 24.1849 14.7216 23.7963 15.1102L21.1102 17.7963C20.7216 18.1849 20.5273 18.3792 20.3032 18.452C20.1061 18.516 19.8939 18.516 19.6968 18.452C19.4727 18.3792 19.2784 18.1849 18.8898 17.7963L16.2037 15.1102Z",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5H23",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedNewsIcon);
export default __webpack_public_path__ + "static/media/relatedNewsIcon.5b0040384317b26c13c2b767f89c2803.svg";
export { ForwardRef as ReactComponent };